import { componentSelector } from 'wordpress/selectors'

import '../styles/Corporate.scss'

const corporateConfigurationSelector = componentSelector('corporate')

export const Corporates = ({ corporate }) => {
    const getLink = children =>
        corporate.buttonAction === 'page' ? (
            <Link className="btn btn-success" to={corporate.page}>
                {children}
            </Link>
        ) : (
            <a className="btn btn-success" href={corporate.url}>
                {children}
            </a>
        )

    return (
        <div className="corporate container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={corporate.image} background />
                <div className="info-container">
                    <h2>{corporate.title}</h2>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text">{corporate.content}</div>
                    {getLink(corporate.buttonLabel)}
                </div>
            </div>
        </div>
    )
}

export const Corporate = corporate => (corporate.enabled ? <Corporates corporate={corporate} /> : null)

export default connect(corporateConfigurationSelector)(Corporate)
